import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const SortArrowDown = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.63793 9.29801C4.82837 9.09805 5.14486 9.09033 5.34483 9.28077L7.5 11.3333L7.5 4.49998C7.5 4.22384 7.72386 3.99998 8 3.99998C8.27614 3.99998 8.5 4.22384 8.5 4.49998L8.5 11.3333L10.6552 9.28077C10.8551 9.09033 11.1716 9.09805 11.3621 9.29801C11.5525 9.49798 11.5448 9.81447 11.3448 10.0049L8.34483 12.8621C8.15172 13.046 7.84828 13.046 7.65517 12.8621L4.65517 10.0049C4.45521 9.81447 4.44749 9.49798 4.63793 9.29801Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default SortArrowDown
